import { compose } from 'redux';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import { reduxForm } from 'redux-form';
import React from 'react';
import PropTypes from 'prop-types';
import { SUBJECT_INHERITED } from 'constants/pitch';

const StepsForm = ({
  renderPitch, step, stepIndex,
}) => (
  <form>
    {step.pitches.map((pitch, pitchKey) => renderPitch(pitch, stepIndex, pitchKey))}
  </form>
);

// eslint-disable-next-line import/prefer-default-export
export const StepsFormRedux = compose(
  connect(state => ({
    initialValues: !isEmpty(state.contactPitchPreviews.steps) &&
            state.contactPitchPreviews.steps.map((step, i) => step.pitches.map(pitch => ({
              body: pitch.body,
              subject: pitch.inherits_subject ? SUBJECT_INHERITED : pitch.subject,
            })).reduce((acc, el, idx) => {
              acc[`pitchPreview-${i}-${idx}`] = el;
              return acc;
            }, {})).reduce((acc, el) => ({ ...acc, ...el })),
  })),
  reduxForm({
    form: 'stepsForm',
    enableReinitialize: true,
    destroyOnUnmount: false,
  }),
)(StepsForm);

StepsForm.propTypes = {
  step: PropTypes.shape({}).isRequired,
  stepIndex: PropTypes.number.isRequired,
  renderPitch: PropTypes.func.isRequired,
};
